import { tokens } from "../../../styles/theme";
import Header from "../../../components/Header";
import React, { useEffect, useState } from "react";
import { Box, useTheme, Button } from "@mui/material";
import axios from "axios";
import { Link } from "react-router-dom";
import ConfirmDialog from "../global/ConfirmDialog";
import * as sweetalert from "sweetalert";
import {
  DataGridPro,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
} from "@mui/x-data-grid-pro";
import PropTypes from "prop-types";
import { getAllServices } from "../../../services/Services";
import packageJson from "../../../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
function EditToolbar(props) {
  return (
    <>
      <GridToolbarContainer></GridToolbarContainer>
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport
          csvOptions={{
            fileName: "الخدمات",
            utf8WithBom: true,
          }}
        />
      </GridToolbarContainer>
    </>
  );
}
EditToolbar.propTypes = {
  setRowModesModel: PropTypes.func.isRequired,
};

const Services = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [rowModesModel, setRowModesModel] = React.useState({});
  const [rows, setRows] = React.useState();
  useEffect(() => {
    setIsLoading(true);

    getAllServices()
      .then((res) => {
        setUsers(res);
        setIsLoading(false);
      })
      .catch((err) => {
        setUsers([]);
        setIsLoading(false);
      });

    return () => {};
  }, []);

  const handleRowEditStart = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleRowEditStop = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleActive = (id) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });

    axios
      .get(
        `${BaseUrl}/api/activateService/${id}`,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        sweetalert("تمت التفعيل بنجاح", {
          className: "alert-div",
          button: {
            text: "تم",
          },
        }).then((res)=>{window.location.reload()});
        // setUsers(users.filter((row) => row.id !== id));
      });
  };
  const handleunActive = (id) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });

    axios
      .get(
        `${BaseUrl}/api/deactivateService/${id}`,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        sweetalert("تمت إلغاءالتفعيل  بنجاح", {
          className: "alert-div",
          button: {
            text: "تم",
          },
        }).then((res)=>{window.location.reload()});
        // setUsers(users.filter((row) => row.id !== id));
      });
  };

  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
    return updatedRow;
  };

  const columns = [
    {
      field: "name_ar",
      headerName: "اسم الخدمة",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
    },
    {
      field: "is_active",
      headerName: "حالة الخدمة",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
      renderCell: (params) => {
        const isActive = params.value === 1;
        return isActive ? "مفعل" : "غير مفعل";
      },
    },

    {
      field: "actions",
      type: "actions",
      headerName: "اجراءات",
      headerAlign: "center",
      align: "center",
      width: 900,
      minWidth: 500,
      maxWidth: 200,
      cellClassName: "actions",
      renderCell: (params) => {
        return (
          <Box>
            {params.row.is_active === 0 ? (
              <>
                <Button
                  variant="contained"
                  color="primary"
                  className="activationbtn"
                  onClick={() => {
                    setConfirmDialog({
                      isOpen: true,
                      title: "هل تريد القيام بهذه العملية",
                      subTitle: "",
                      onConfirm: () => {
                        handleActive(params.row.id);
                      },
                    });
                  }}
                >
                  تفعيل
                  <img
                    src="activate-icon.svg"
                    className="icondelete"
                    alt="delete icon"
                  ></img>
                </Button>
                <ConfirmDialog
                  confirmDialog={confirmDialog}
                  setConfirmDialog={setConfirmDialog}
                />
              </>
            ) : (
              <>
                <Button
                  variant="contained"
                  color="primary"
                  className="activationbtn3"
                  onClick={() => {
                    setConfirmDialog({
                      isOpen: true,
                      title: "هل تريد القيام بهذه العملية",
                      subTitle: "",
                      onConfirm: () => {
                        handleunActive(params.row.id);
                      },
                    });
                  }}
                >
                  إلغاء التفعيل
                </Button>
                <ConfirmDialog
                  confirmDialog={confirmDialog}
                  setConfirmDialog={setConfirmDialog}
                />
              </>
            )}
          </Box>
        );
      },
    },
  ];
  return (
    <Box m="2px 5px 0px 5px">
      <Header />

      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.redAccent[1100],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.redAccent[1100],
            borderBottom: "none",
            fontSize: "10px !important",
          },
          "& .MuiDataGrid-cellContent": {
            fontSize: "10px !important",
            color: `${colors.grey[600]} !important`,
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.white[100],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.redAccent[1100],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >
        <DataGridPro
          rows={users}
          className="field-table"
          columns={columns}
          editMode="row"
          pageSize={10}
          pagination
          rowModesModel={rowModesModel}
          onRowModesModelChange={(newModel) => setRowModesModel(newModel)}
          onRowEditStart={handleRowEditStart}
          onRowEditStop={handleRowEditStop}
          processRowUpdate={processRowUpdate}
          components={{
            Toolbar: EditToolbar,
          }}
          localeText={{
            toolbarColumns: "الأعمدة",
            toolbarFilters: "الفلاتر",
            toolbarDensity: "التباعد",
            toolbarExport: "تصدير",
            filterPanelAddFilter: "إضافة فلتر",
            filterOperatorContains: "تحتوي",
            filterOperatorEquals: "تساوي",
            filterOperatorStartsWith: "تبدأ ب",
            filterOperatorEndsWith: "تنتهي  ب",
            filterOperatorIsAnyOf: "هو أي من",
            filterOperatorIsEmpty: "فارغ",
            filterOperatorIsNotEmpty: "غير فارغ",
            toolbarDensityCompact: "دمج",
            toolbarDensityStandard: "معيار",
            toolbarDensityComfortable: "مريح",
            toolbarExportCSV: "تصدير CSV",
            toolbarExportPrint: "طباعة",
            filterPanelInputLabel: "القيمة",
            filterPanelInputPlaceholder: "ادخل القيمة",
            filterPanelColumns: "الاعمدة",
            filterPanelOperators: "العمليات",
            columnsPanelTextFieldLabel: "بحث عن عمود",
            columnsPanelTextFieldPlaceholder: "عنوان العمود",
          }}
          componentsProps={{
            toolbar: { setRows, setRowModesModel },
          }}
          experimentalFeatures={{ newEditingApi: true }}
        />
      </Box>
    </Box>
  );
};

export default Services;
